import { get, post, del, put } from '@api/request';
// import { defaultPageSize } from '../../constants';

export async function fetchAllObjects(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/screenconfiguration/objects`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSubcomponentsForObject(
  { appraisalService },
  authenticationToken,
  { object },
) {
  const url = `${appraisalService}/appraisal/screenconfiguration/object/${object}/subcomponents`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSubcomponents(
  { appraisalService },
  authenticationToken,
  { searchOptions },
) {
  let url = `${appraisalService}/appraisal/screenconfiguration/subcomponents`;

  if (searchOptions && searchOptions.object) {
    url += `&object=${searchOptions.object}`;
  }
  // add search by subcomponent name later

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSubcomponent(
  { appraisalService },
  authenticationToken,
  { subcomponentId },
) {
  const url = `${appraisalService}/appraisal/screenconfiguration/subcomponent/${subcomponentId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createSubcomponent(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/screenconfiguration/subcomponents`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function updateSubcomponent(
  { appraisalService },
  authenticationToken,
  { subcomponentId, data },
) {
  const url = `${appraisalService}/appraisal/screenconfiguration/subcomponent/${subcomponentId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function deleteSubcomponent(
  { appraisalService },
  authenticationToken,
  { subcomponentId },
) {
  const url = `${appraisalService}/appraisal/screenconfiguration/subcomponent/${subcomponentId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}
